// ----------------------------------------------------------------------

import { alpha } from "@mui/material/styles";

export default function Accordion(theme) {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          // marginBottom: theme.spacing(2),
          borderRadius: "16px !important",
          backgroundColor: theme.palette.background.card,
          boxShadow: "none",
          "&::before": {
            backgroundColor: "unset",
          },
          "&.Mui-expanded": {
            boxShadow: theme.customShadows.z8,
            borderRadius: theme.shape.borderRadius,
          },
          "&.Mui-disabled": {
            backgroundColor: "transparent",
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(1),
          paddingRight: 0,
          paddingLeft: 0,
          paddingBottom: 0,
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          borderRadius: "16px !important",
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          color: theme.palette.primary.main,
          // padding: theme.spacing(2),
          // paddingRight: theme.spacing(1),
          "&.Mui-disabled": {
            opacity: 1,
            color: theme.palette.action.disabled,
            "& .MuiTypography-root": {
              color: "inherit",
            },
          },
        },

        expandIconWrapper: {
          color: "inherit",
        },
      },
    },
  };
}
